<template>
  <span
    class="toggleMini"
    :class="getIsSidebarToggled ? 'toggleMini--active' : ''"
    @click="toggleClick()"
  >
    <i class="icon" :class="'icon-' + (getIsSidebarToggled ? 'menu' : 'arrow-left')"></i>
  </span>
</template>

<script>
import EventBus from '@/globals/eventBus'

export default {
  name: 'DrMenuToggle',

  data () {
    return {
      EventBus
    }
  },

  computed: {
    getIsSidebarToggled () {
      return this.$store.getters.getIsSidebarToggled
    }
  },

  watch: {
    isToggled: {
      deep: false,
      immediate: true,
      handler (v) {
        this.$store.dispatch('setIsSidebarToggled', v)
      }
    }
  },
  methods: {
    toggleClick () {
      this.$store.dispatch('setIsSidebarToggled', !this.getIsSidebarToggled)
      this.EventBus.$emit('resize-telemedicine-container')
    }
  }
}
</script>
